import { gql } from "@apollo/client";
export const LOCKER_TYPE_FOR_LOCKER_STORAGE_FEES = gql`
  {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;

export const USER_TYPE_FOR_LOCKER_STORAGE_FEES = gql`
  query ($operatorId: ID!) {
    lockerUserTypes(operatorId: $operatorId) {
      userTypeId
      userType
    }
  }
`;
export const DOOR_SIZES_FOR_LOCKER_STORAGE_FEES = gql`
  {
    doorSizes {
      doorSizeId
      doorSize
    }
  }
`;
export const STORAGE_SIZE_FEE = gql`
  query (
    $operatorId: ID!
    $userTypeId: ID!
    $lockerTypeId: ID!
    $doorSizeId: ID!
  ) {
    storageSizeFee(
      operatorId: $operatorId
      userTypeId: $userTypeId
      lockerTypeId: $lockerTypeId
      doorSizeId: $doorSizeId
    ) {
      storageSizeFeeId
      excessFeePerInc
      incByHours
      maxOverstayCharge
    }
  }
`;
export const STORAGE_TIME_FEES = gql`
  query (
    $operatorId: ID!
    $userTypeId: ID!
    $lockerTypeId: ID!
    $doorSizeId: ID!
  ) {
    storageTimeFees(
      operatorId: $operatorId
      userTypeId: $userTypeId
      lockerTypeId: $lockerTypeId
      doorSizeId: $doorSizeId
    ) {
      storageTimeFeeId
      fee
      hours
    }
  }
`;

export const UPDATE_STORAGE_TIME_FEE = gql`
  mutation ($storageTimeFeeList: [StorageTimeFeeObject!]!) {
    updateStorageTimeFee(storageTimeFeeList: $storageTimeFeeList) {
      storageTimeFee {
        storageTimeFeeId
      }
    }
  }
`;
export const UPDATE_STORAGE_SIZE_FEE = gql`
  mutation (
    $operatorId: ID!
    $lockerTypeId: ID!
    $userTypeId: ID!
    $doorSizeId: ID!
    $storageSizeFeeId: ID!
    $excessFeePerInc: Float!
    $incByHours: Int!
    $maxOverstayCharge: Float!
  ) {
    updateStorageSizeFee(
      operatorId: $operatorId
      lockerTypeId: $lockerTypeId
      userTypeId: $userTypeId
      doorSizeId: $doorSizeId
      storageSizeFeeId: $storageSizeFeeId
      excessFeePerInc: $excessFeePerInc
      incByHours: $incByHours
      maxOverstayCharge: $maxOverstayCharge
    ) {
      storageSizeFee {
        storageSizeFeeId
      }
    }
  }
`;

